import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NumberTagNotUsedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.numberings.validation.format.number-tag-not-used');
    }
}
